module.exports = __webpack_public_path__ + "media/images/attachement-preview-03-dd467b9dd4f02b28111b40870a5ddc59.jpg";